import * as React from "react";
import { PortalContext } from "@/context/PortalContext";
import { APIService } from "@/services/APIService/APIService";
import { useService } from "@/services/ServiceContext";
import useSWRImmutable from "swr/immutable";
import { mutate } from "swr";
import { useSuperUserContext } from "@/context/SuperUserContext";
export function useCustomers() {
	const svc = useService(APIService.serviceKey);
	const { isSuperUser } = useSuperUserContext();
	return useSWRImmutable(["customers", isSuperUser && "all"], async () => {
		const customers = await svc.customer.getCustomers({ all: isSuperUser });
		customers.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
		customers.forEach((i) => {
			mutate(["customer", i.id], i, false);
		});
		return customers;
	});
}

export function useCustomer(id: string | null | undefined) {
	const svc = useService(APIService.serviceKey);
	const customer = useSWRImmutable(["customer", id], async () => {
		if (!id) return null;

		const customers = await svc.customer.getCustomer({ id });
		return customers;
	});

	return customer;
}

function timeOut(timeout: number) {
	return new Promise((resolve) => {
		setTimeout(resolve, timeout);
	});
}

export function useSelectedCustomer() {
	const portalCtx = React.useContext(PortalContext);

	return useCustomer(portalCtx.selectedCustomerId);
}

export function useCustomerContacts() {
	const { data: customer } = useSelectedCustomer();
	const svc = useService(APIService.serviceKey);

	return useSWRImmutable(["customer-contacts", customer?.id], async () => {
		if (!customer?.id) return [];

		const customers = await svc.customer.getCustomerContacts({ id: customer.id });
		customers.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
		return customers;
	});
}
